(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modern-product-detail"] && !Shopify.designMode) return;
  try {
    
  class ModernProductDetail extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.media = [...this.querySelectorAll('.modern-pdp__media')];
      this.thumbs = [...this.querySelectorAll('.modern-pdp__thumb')];
      this.form = this.querySelector('[data-product-form]');
      this.bindGallery();
      this.bindOptions();
      this.bindQuantity();
      this.bindTabs();
      this.bindDialog();
      this.loadRecommendations();
      this.addEventListener('shopify:block:select', (event) => { const panel = event.target.closest('[data-panel]'); if (panel) this.querySelector(`[data-tab="${panel.dataset.panel}"]`)?.click(); });
    }
    bindGallery() {
      this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaId)));
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.stepMedia(-1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.stepMedia(1));
    }
    showMedia(id) {
      this.media.forEach((item) => { const active = item.dataset.mediaId === String(id); item.hidden = !active; item.classList.toggle('is-active', active); });
      this.thumbs.forEach((item) => { const active = item.dataset.mediaId === String(id); item.classList.toggle('is-active', active); item.setAttribute('aria-current', active); });
    }
    stepMedia(direction) {
      const current = this.media.findIndex((item) => !item.hidden);
      const next = (current + direction + this.media.length) % this.media.length;
      this.showMedia(this.media[next].dataset.mediaId);
    }
    bindOptions() {
      this.querySelectorAll('.modern-pdp__choice-input').forEach((input) => input.addEventListener('change', () => {
        input.closest('fieldset').querySelector('[data-selected-option]').textContent = input.value;
        const choices = [...this.querySelectorAll('.modern-pdp__option')].map((fieldset) => fieldset.querySelector('input:checked')?.value);
        const variant = this.variants.find((item) => item.options.every((value, index) => value === choices[index]));
        if (!variant) return;
        this.querySelector('[data-variant-id]').value = variant.id;
        const button = this.querySelector('[data-add-to-cart]');
        button.disabled = !variant.available;
        button.querySelector('span').textContent = variant.available ? button.dataset.addLabel : button.dataset.soldoutLabel;
        const price = this.querySelector(`[data-variant-price="${variant.id}"]`);
        if (price) this.querySelector('[data-price]').textContent = price.textContent;
        if (variant.featured_media) this.showMedia(variant.featured_media.id);
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      }));
    }
    bindQuantity() {
      const input = this.querySelector('[data-quantity]');
      this.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value) - 1); });
      this.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { input.value = Number(input.value) + 1; });
    }
    bindTabs() {
      const tabs = [...this.querySelectorAll('[data-tab]')];
      const activate = (tab) => {
        tabs.forEach((item) => { item.setAttribute('aria-selected', item === tab); item.tabIndex = item === tab ? 0 : -1; });
        this.querySelectorAll('[data-panel]').forEach((panel) => { panel.hidden = panel.dataset.panel !== tab.dataset.tab; });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus();
        });
      });
    }
    bindDialog() {
      const dialog = this.querySelector('[data-size-guide-dialog]');
      this.querySelectorAll('[data-size-guide-open]').forEach((button) => button.addEventListener('click', () => dialog.showModal()));
      this.querySelector('[data-size-guide-close]')?.addEventListener('click', () => dialog.close());
    }
    async loadRecommendations() {
      const holder = this.querySelector('[data-recommendations]');
      if (!holder || holder.querySelector('.modern-pdp__product-grid')) return;
      const url = `${window.Shopify.routes.root}recommendations/products?product_id=${holder.dataset.productId}&limit=${holder.dataset.limit || 5}&section_id=${this.dataset.sectionId}`;
      const response = await fetch(url);
      if (!response.ok) return;
      const html = document.createElement('div'); html.innerHTML = await response.text();
      const grid = html.querySelector('[data-recommendations] .modern-pdp__product-grid');
      if (grid) holder.append(grid);
    }
  }
  if (!customElements.get('modern-product-detail')) customElements.define('modern-product-detail', ModernProductDetail);

  } catch(e) { console.error(e); }
})();
})();
